import { Button } from '@ui/themed';
import type { ReactNode } from 'react';
import { SettingRow } from './setting-row';
import type { StaffAccess } from './staff-setting';

export function SettingActionRow({
  label,
  description,
  learnMoreUrl,
  actionLabel,
  onAction,
  disabled = false,
  tooltip,
  nested,
  staff,
}: {
  label: ReactNode;
  description?: ReactNode;
  learnMoreUrl?: string;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
  tooltip?: string;
  nested?: boolean;
  /** No `write`: an action row has nowhere to explain a locked button. */
  staff?: Extract<StaffAccess, 'read-write'>;
}) {
  return (
    <SettingRow
      label={label}
      description={description}
      learnMoreUrl={learnMoreUrl}
      tooltip={tooltip}
      align="center"
      nested={nested}
      staff={staff}
      control={
        <Button variant="secondary" onClick={onAction} disabled={disabled}>
          {actionLabel}
        </Button>
      }
    />
  );
}
